import { render, staticRenderFns } from "./site-size.vue?vue&type=template&id=4d8a00c7&scoped=true"
import script from "./site-size.vue?vue&type=script&lang=js"
export * from "./site-size.vue?vue&type=script&lang=js"
import style0 from "./site-size.vue?vue&type=style&index=0&id=4d8a00c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8a00c7",
  null
  
)

export default component.exports